/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react'
import { SidebarMenuItem } from './SidebarMenuItem'
// import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getDeletedCards } from '../../../../../redux/action/card'
import { useDispatch } from 'react-redux'
import { signOut } from 'firebase/auth';
import { auth } from '../../../../../firebase'; // adjust the import to your firebase setup file
import { KTIcon } from '../../../../helpers'
import { mimicLogin } from '../../../../../redux/action/auth'


const SidebarMenuMain = () => {
  const dispatch = useDispatch();
  const isAdmin = useSelector((state: any) => state.Auth?.authProfile?.userData?.protected?.isAdmin)
  const cards = useSelector((state: any) => state.Card.DeletedCard)
  
  // Get account switching state  
  const isAdminMode = localStorage.getItem('isAdminMode') === 'true'
  const mimicId = localStorage.getItem('mimicId')
  const originalAdminId = localStorage.getItem('originalAdminId')
  
  // Determine if admin is viewing another account
  const isAdminViewing = Boolean(mimicId || isAdminMode)
  
  // Determine if user should have admin privileges
  // Either they are an admin of their own account, or they are an admin viewing another account
  const hasAdminPrivileges = isAdmin || isAdminViewing
  
  // const navigate = useNavigate()

  useEffect(() => {
    dispatch(getDeletedCards())
  }, [])

  const handleBackToAdmin = async () => {
    try {
      if (mimicId) {
        // Handle mimicId case (legacy)
        dispatch(
          mimicLogin({
            uid: mimicId
          })
        ).then((res) => {
          localStorage.removeItem('mimicId')
          window.location.replace("/dashboard");
        })
      } else if (isAdminMode && originalAdminId) {
        // Handle new account switching case
        const { switchBackToAdmin } = await import('../../../../../redux/action/account')
        await dispatch(switchBackToAdmin())
        window.location.replace('/tools') // Go back to admin tools
      }
    } catch (error) {
      console.error('Failed to return to admin:', error)
      // Fallback: clear all admin tokens and redirect
      localStorage.removeItem('mimicId')
      localStorage.removeItem('isAdminMode')
      localStorage.removeItem('originalAdminId')
      window.location.replace("/tools")
    }
  }

  const handleSignOut = async () => {
    await signOut(auth);
    localStorage.removeItem("userId");
    localStorage.removeItem('mimicId')
    localStorage.removeItem('isAdminMode')
    localStorage.removeItem('originalAdminId')
    window.location.replace("/auth");
  }

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='bi bi-file-earmark'
        title='My Experiences'
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItem
        to='/markers'
        icon='bi bi-qr-code-scan'
        title='My Prints'
        fontIcon='bi-qr-code-scan'
      />
      <SidebarMenuItem
        to='/orders'
        icon='bi bi-box2'
        title='My Orders'
        fontIcon='bi-app-indicator'
      />
       <SidebarMenuItem
        to='/analytics/overview/all'
        icon='bi bi-bar-chart-line-fill'
        title='My Analytics'
        fontIcon='bi-bar-chart-line-fill'
      />
      <SidebarMenuItem
        to='/account'
        icon='bi bi-person-circle'
        title='My Account'
        fontIcon='bi-person-circle'
      />
      {/*hasAdminPrivileges && <SidebarMenuItem
        to='/editor'
        icon='bi bi-pencil-square'
        title='Scene Editor'
        fontIcon='bi-pencil-square'
      />*/}
      {hasAdminPrivileges && <SidebarMenuItem
        to='/tools'
        icon='bi bi-tools'
        title='Admin Tools'
        fontIcon='bi-tools'
      />}
      {
        cards?.length > 0 &&(
          <>

        <SidebarMenuItem
          to='/trashcard'
          icon='bi bi-trash3'
          title='Trash'
          fontIcon='bi-layers'
        /></>
      )}

      {/* Sign Out / Back to Admin */}
      <div className='menu-item' onClick={isAdminViewing ? handleBackToAdmin : handleSignOut}>
        <div className='menu-link without-sub text-dark'>
          <span className='menu-icon'>
            {' '}
            <KTIcon 
              iconName={isAdminViewing ? 'ki-solid ki-black-left-line' : 'ki-solid ki-entrance-left'} 
              className='fs-2x' 
            />
          </span>
          <span style={{ fontWeight: "400" }} className='menu-title'>
            {isAdminViewing ? 'Back to Admin' : 'Sign Out'}
          </span>
        </div>
      </div>

      {/* <div className='position-absolute bottom-0 flex-column-auto pt-2 pb-6 w-100'> */}
      {/* <PaymentWarning userdata={userdata} /> */}
      {/*<SidebarMenuItem to='/Plan' icon='bi bi-gear' fontIcon='' title='Learn with us' />*/}
      {/*
        <SidebarMenuItemWithSub to='/apps/chat' title='Settings' fontIcon='bi bi-gear' icon='bi bi-layout-split'>
          <SidebarMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
          <SidebarMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
          <SidebarMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
        </SidebarMenuItemWithSub>
        */}
      {/* </div> */}
    </>
  )
}

export { SidebarMenuMain }
